import React, {ReactElement} from 'react';
import classnames from 'classnames';

// Define props interface
interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: ReactElement; // Type for any renderable node
    size?: number; // Size in pixels
}

const IconButton: React.FC<IconButtonProps> = ({
    icon,
    size = 20,
    className,
    ...rest
}) => {
    const clonedIcon = React.cloneElement(icon, {
        size // Directly pass the size prop if the icon supports it
    });

    const classNames = classnames('btn-icon', className);
    return (
        <button className={classNames} {...rest}>
            {clonedIcon}
        </button>
    );
};

export default IconButton;
